import "./styles.scss";

import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";

import { useNewWebsite } from "context/client/new_website";

import ModalNew from "components/ModalNew";
import SubscriptionPlan from "../../../steps/ChoosePlan/components/SubscriptionPlan";
import Button from "components/Button";

import choosePlanSchema from "libs/validations/new_website_form/choosePlanSchema";

const mainClass = "new-website-content__widget__plan-modal";

const PlanModal = ({ current, isOpen, onClose }) => {
  const { t } = useTranslation();

  const { saveData, form_data } = useNewWebsite();

  const onSubmit = (values) => {
    saveData(values);

    if (typeof onClose === "function") onClose();
  };

  return (
    <ModalNew
      title={t("Change plan")}
      description={t("Choose the plan that suits you best.")}
      variant="very-wide"
      isOpen={isOpen}
      isSubmitHidden
      onClose={onClose}
    >
      <Formik
        initialValues={{
          website: form_data?.website || "",
          plan: form_data?.plan || null,
          billed_type: form_data?.billed_type || "monthly",
        }}
        validationSchema={choosePlanSchema}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(values, setSubmitting);
        }}
      >
        {({ values }) => (
          <Form className={mainClass} autoComplete="off">
            <div className={`${mainClass}__row`}>
              <div className={`${mainClass}__column`}>
                <SubscriptionPlan
                  current={
                    current?.plan && current?.billed_type
                      ? current
                      : {
                          plan: form_data.plan,
                          billed_type: form_data.billed_type,
                        }
                  }
                />
              </div>
              <div className={`${mainClass}__column`}>
                <Button
                  type="submit"
                  disabled={values?.plan === form_data.plan}
                >
                  {t("Update data")}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </ModalNew>
  );
};

export default PlanModal;
